module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0013.jpg?v=2b238f7d";